import React from 'react';
import { APP_META } from '../../services/config';

// Square Z mark from the Zear launchpad, used where a small icon is needed.
export const AppLogoMark = ({ size = 24 }: { size?: number }) => {
  const src = APP_META.logoUrl || '/brand/mark.png';
  return (
    <img
      src={src}
      alt=""
      style={{ height: size, width: size, objectFit: 'contain' }}
    />
  );
};

// Full Zear wordmark, the same image as https://www.zearfun.xyz/brand/logo.png
export const AppLogo = ({
  className = '',
  onClick,
}: {
  size?: number;
  className?: string;
  onClick?: () => void;
}) => (
  <div className={`flex items-center ${className}`} onClick={onClick}>
    <img
      src="/brand/logo.png"
      alt={APP_META.name}
      style={{ height: 32, width: 'auto' }}
    />
  </div>
);
